import React, { useState, useEffect } from 'react'
import { useSelector } from "react-redux";
import Cookies from "universal-cookie";
import { fetchApi } from '../../tools';
import { get } from '../../asignacion-horario/services/General.service';



  const SedesCirculos = ({ setInfoSede, infoSede, instructions, sede }) => {

    function transformSedes(content) {
      let transformed = content
      transformed.map(e => {
            if(e.Iniciales === 'Z7'){
                e.Iniciales = 'SJ'
            }
            if(e.Iniciales === 'Z12'){
                e.Iniciales = 'PT'
            }
            if(e.Iniciales === 'EN'){
                e.Iniciales = 'NJ'
            }
            if(e.Iniciales === 'VB'){
                e.Iniciales = 'VD'
            }
            if(e.Iniciales === 'AJ'){
                e.Iniciales = 'JC'
            }
        })
        return transformed
    }

    const user = useSelector((state) => state.auth.user);
    const userObj = JSON.parse(user);
    const cookies = new Cookies();
    const urlCursos = cookies.get("__urlCursosApi"); // url para enviar al api viene de cookies
    const url = cookies.get("__urlSchoolApi"); // url para enviar al api viene de cookies
    const { headersAPI: headers } = useSelector((state) => state.url); // Headers para enviar al api viene de redux

    const loadSedes = async () => {
      console.log(url)
      console.log(headers)
      try {
        const response = await fetchApi({
          url: url + "/utils/busquedas",
          headers: headers,
          content: { opcion: "SEDES" },
        });
        setInfoSede({
          ...infoSede,
          Sedes: transformSedes(response),
          IdSede: sede,
      })
        //setSedes(response);
      } catch (error) {}
    };


    const getSedes = async () => {
        const response = await fetchApi({
            url: urlCursos + `/utils/busquedas`, // reparar
            headers: headers,
            content: {
                Opcion: "SEDES"
            }
        })
        setInfoSede({
            ...infoSede,
            Sedes: response.msg,
            IdSede: sede,
        })
      }

      useEffect(() => {
        //getSedes()
        loadSedes()
      }, []);
      

      
  return (
    <>
    <div className={"flex flex-row"}>
                {infoSede?.Sedes?.map((element, index) => (
                  <>
                  <div key={index + Math.random(1000)} className="flex flex-row">
                  <div
                    key={index  + Math.random(1000)} 
                    className={  infoSede?.IdSede === element['IdSede'] ? 
                    "grid m-1 w-20 h-20 rounded-full ring-azulBrillanteMira  ring-1 bg-azulBrillanteMira hover:shadow-md hover:shadow-white":
                    "grid m-1 w-20 h-20 rounded-full ring-azulBrillanteMira  ring-1 hover:bg-azulBrillanteMira hover:shadow-md hover:shadow-white" }
                     onClick={() =>  setInfoSede({...infoSede, IdSede:element['IdSede']})}
                     onMouseEnter={() => setInfoSede({...infoSede, Nombre: element.Nombre})}
                    >
                    <p className="m-auto text-white text-2xl font-bold">
                      {infoSede.Sedes[index]["Iniciales"]}
                      </p>
                  </div>
                  <p className="block lg:hidden m-auto text-white">
                    {element?.Nombre}
                    </p>
                  </div>
                  </>
                  ))}

              <div className={"flex lg:w-1/2 w-full flex-col"}>
                  <p className="text-secundario m-auto hidden xl:inline">{instructions}</p>
                  { true ? <p className={"m-auto text-white hidden xl:flex"}>{infoSede?.Nombre}</p>: null}
              </div>
            </div>
    </>
  )
}

export default SedesCirculos